(function(root, factory) {
  var globalRoot = root || {};

  if (globalRoot.DYOFLaunchContract && globalRoot.DYOFLaunchContract.__loaded) {
    if (typeof module === "object" && module.exports) {
      module.exports = globalRoot.DYOFLaunchContract;
    }
    return;
  }

  var contract = factory(root);
  globalRoot.DYOFLaunchContract = contract;

  if (typeof module === "object" && module.exports) {
    module.exports = contract;
  }
})(typeof globalThis !== "undefined" ? globalThis : this, function(root) {
  "use strict";

  // Translations (assets/dyof-i18n.js, non-English stores only). The English
  // stays here and is used as is when no language pack is loaded.
  function dyofInterpolate(text, params) {
    return params ? String(text).replace(/\{([A-Za-z0-9_]+)\}/g, function(match, name) {
      return Object.prototype.hasOwnProperty.call(params, name) && params[name] != null ? String(params[name]) : match;
    }) : text;
  }
  function dyofT(key, english, params) {
    var i18n = root.DYOFI18n;
    return i18n ? i18n.t(key, english, params) : dyofInterpolate(english, params);
  }
  function dyofPlural(key, count, english, params) {
    var i18n = root.DYOFI18n;
    var values = Object.assign({ count: count }, params || {});
    return i18n ? i18n.plural(key, count, english, params) : dyofInterpolate(Number(count) === 1 ? english.one : english.other, values);
  }
  function readStoreProfile(scope) {
    var node = scope && scope.document && typeof scope.document.querySelector === "function"
      ? scope.document.querySelector("script[data-dyof-store-profile]")
      : null;
    if (!node) {
      return null;
    }
    try {
      var profile = JSON.parse(node.textContent || "null");
      return profile && typeof profile === "object" ? profile : null;
    } catch (error) {
      return null;
    }
  }


  var HEADER_THEMES = [
    "to-dos",
    "notes",
    "wellness",
    "self-care",
    "productivity",
    "mindful"
  ];
  var DATE_POSITIONS = ["left-aligned", "outer"];
  var PAPER_COLOURS = ["white", "cream"];
  var COLOUR_MODES = ["signature-multicolour", "single-colour"];
  // A non-UK store's profile (shopify-themes/dyof-store-cz) chooses its refill
  // languages and adds its own holiday groups; the UK has no profile.
  var STORE_PROFILE = readStoreProfile(root);
  var LANGUAGES = STORE_PROFILE && Array.isArray(STORE_PROFILE.contentLanguages) && STORE_PROFILE.contentLanguages.length
    ? STORE_PROFILE.contentLanguages.filter(function(code) { return /^[a-z]{2,3}$/.test(String(code)); })
    : ["en", "de", "es", "fr"];
  var PERSONALISATION_COLOURS = [
    "#9F4149",
    "#E89E8B",
    "#DE9BBF",
    "#875A86",
    "#4C5E81",
    "#3163A6",
    "#77B3C1",
    "#8EB690",
    "#456969",
    "#9BAC9B",
    "#806030",
    "#1C1B1A"
  ];
  var MINIMAL_FIRST_PAGE_COLOURS = ["#666666"];
  var FIRST_PAGE_COLOURS = ["#FFFFFF", "#1C1B1A"];
  var COUNTRY_HOLIDAY_GROUPS = [
    "Australia",
    "Austria",
    "Belgium",
    "Canada",
    "China",
    "Denmark",
    "Finland",
    "France",
    "Germany",
    "Greece",
    "Iceland",
    "India",
    "Indonesia",
    "Ireland",
    "Italy",
    "Japan",
    "Korea",
    "Malaysia",
    "Mexico",
    "Netherlands",
    "New Zealand",
    "Norway",
    "Philippines",
    "Portugal",
    "Singapore",
    "Spain",
    "Sweden",
    "Switzerland",
    "Taiwan",
    "Ukraine",
    "United Kingdom",
    "United States"
  ];
  if (STORE_PROFILE && Array.isArray(STORE_PROFILE.holidayGroups)) {
    COUNTRY_HOLIDAY_GROUPS = STORE_PROFILE.holidayGroups.filter(function(group) {
      return typeof group === "string" && group && COUNTRY_HOLIDAY_GROUPS.indexOf(group) === -1;
    }).concat(COUNTRY_HOLIDAY_GROUPS);
  }
  var RELIGIOUS_HOLIDAY_GROUPS = [
    "Chinese",
    "Christian",
    "Christian Orthodox",
    "Hindu",
    "Jewish",
    "Muslim"
  ];
  var PERSONAL_DATE_FREQUENCIES = ["one-time", "weekly", "monthly"];
  var MOON_TIMEZONE_OFFSETS = [];
  var timezoneOffset;

  for (timezoneOffset = -720; timezoneOffset <= 840; timezoneOffset += 60) {
    MOON_TIMEZONE_OFFSETS.push(timezoneOffset);
  }
  [-270, 210, 270, 330, 345, 390, 570, 630, 765, 825].forEach(function(offset) {
    MOON_TIMEZONE_OFFSETS.push(offset);
  });
  MOON_TIMEZONE_OFFSETS.sort(function(left, right) { return left - right; });
  // A store profile may start moon phases in its own time zone (the Czech
  // store uses +60); anything outside the offered offsets keeps London (0).
  var DEFAULT_MOON_TIMEZONE_OFFSET = STORE_PROFILE
    && MOON_TIMEZONE_OFFSETS.indexOf(Number(STORE_PROFILE.moonTimezoneOffset)) !== -1
    ? Number(STORE_PROFILE.moonTimezoneOffset) : 0;
  var SINGLE_COLOUR_PALETTES = {
    gradient: [
      ["#8DA5CC", "#C8A3CD", "#849EC8", "#D8BEDB", "#B4C3DE"],
      ["#C8A3CD", "#81BAA3", "#70B096", "#87B6A6", "#C49CC9"],
      ["#F39A86", "#E897C1", "#E589B8", "#F29581"],
      ["#66B2DA", "#F8B06B", "#5FAFD8", "#E9B885"],
      ["#81BAA3", "#8DA5CC", "#7D99C5", "#7BB79F"],
      ["#E897C1", "#E589B8", "#E999B8"]
    ],
    waves: [
      ["#CADCB6", "#B4CA8D", "#64B6CA", "#F3F7EE", "#BCDDDC"],
      ["#E5C8E1", "#CDA1CB", "#79A3D7", "#F6ECF4", "#CAD2EA"],
      ["#F5AEA8", "#EC78A1", "#F089AD", "#F8CAC6", "#F7C3CE"]
    ],
    blocks: [
      ["#9FAA96", "#50685C", "#C5CAB2", "#E9ECEB", "#476053"],
      ["#A59198", "#6C4A54", "#E0CCCB", "#EDE8EA", "#F4F1F2"],
      ["#EFB78E", "#D28774", "#E2B1A5", "#D0816D", "#EFD5CE"],
      ["#8EADAF", "#2C4C56", "#B5C7C5", "#E5E9EA", "#F1F5F5"],
      ["#BF8DA7", "#895472", "#F5DEEA", "#F0EAED", "#F7F1F4"],
      ["#8BB4CD", "#3C5979", "#CCDCE2", "#E7EAEE", "#8093A8"]
    ],
    "soft-stripes": [
      ["#F8C7DE", "#E9B1D0", "#F7BFD9", "#E6A6C9", "#DFC5D2"],
      ["#9FC0B9", "#93BEB5", "#BDD4CE", "#92B7AF", "#B4CEC7"],
      ["#B0BF96", "#ACBA88", "#C8D4AC", "#A5B687", "#C0CEA1"],
      ["#F6BB8B", "#F5B27B", "#E0C4A6", "#E0B78E", "#F8CB9C"],
      ["#F0A792", "#F8C0A9", "#EE9B83", "#F7B79D", "#F2AF9A"],
      ["#87ACC6", "#A8C8DB", "#76A1BE", "#9CC0D6", "#E6EFF4"]
    ],
    essential: [
      ["#86B2A5"],
      ["#AC8FB3"],
      ["#839DBC"],
      ["#E0927F"],
      ["#DD99C3"],
      ["#B0C28A"]
    ],
    everyday: [
      ["#86B2A5"],
      ["#AC8FB3"],
      ["#839DBC"],
      ["#E0927F"],
      ["#DD99C3"],
      ["#B0C28A"]
    ]
  };
  var FIRST_PAGE_BACKGROUND_COLOURS = {
    gradient: ["#C8A3CD", "#81BAA3", "#E897C1", "#F9BA7D", "#8DA5CC", "#E897C1"],
    waves: ["#64B6CA", "#79A3D7", "#F089AD"],
    blocks: ["#50685C", "#6C4A54", "#D28774", "#2C4C56", "#895472", "#3C5979"],
    "soft-stripes": ["#E9B1D0", "#93BEB5", "#ACBA88", "#F6BB8B", "#F0A792", "#87ACC6"],
    essential: ["#86B2A5", "#AC8FB3", "#839DBC", "#E0927F", "#DD99C3", "#B0C28A"],
    everyday: ["#86B2A5", "#AC8FB3", "#839DBC", "#E0927F", "#DD99C3", "#B0C28A"]
  };

  var STYLES = {
    minimal: {
      label: dyofT("contract.style.minimal", "Minimal"),
      engine: "legacy"
    },
    classic: {
      label: dyofT("contract.style.classic", "Classic"),
      engine: "legacy"
    },
    luxury: {
      label: dyofT("contract.style.luxury", "Luxury"),
      engine: "legacy"
    },
    gradient: {
      label: dyofT("contract.style.gradient", "Gradient"),
      engine: "modern",
      frameFamily: "gradient",
      singleColourCount: 6
    },
    waves: {
      label: dyofT("contract.style.waves", "Waves"),
      engine: "modern",
      frameFamily: "waves",
      singleColourCount: 3
    },
    blocks: {
      label: dyofT("contract.style.blocks", "Blocks"),
      engine: "modern",
      frameFamily: "blocks",
      singleColourCount: 6
    },
    "soft-stripes": {
      label: dyofT("contract.style.soft_stripes", "Soft Stripes"),
      engine: "modern",
      frameFamily: "soft-lines",
      singleColourCount: 6
    },
    essential: {
      label: dyofT("contract.style.essential", "Essential"),
      engine: "modern",
      frameFamily: "essential",
      singleColourCount: 6
    },
    everyday: {
      label: dyofT("contract.style.everyday", "Everyday"),
      engine: "modern",
      frameFamily: "everyday",
      singleColourCount: 6
    }
  };

  var LEGACY_VARIANTS = {
    daily: {
      label: dyofT("contract.layout.daily", "Daily"),
      controls: ["lineStyle", "calendar", "appointmentTimes"]
    },
    weekly: {
      label: dyofT("contract.layout.weekly", "Weekly"),
      description: dyofT("contract.description.horizontal_week", "Horizontal week to view"),
      controls: ["lineStyle", "calendar", "notes"]
    },
    "two-weeks": {
      label: dyofT("contract.layout.weekly", "Weekly"),
      description: dyofT("contract.description.two_weeks", "Two weeks to view"),
      controls: ["calendar"]
    },
    // Appointment times: ruled only (dyof-state.js), A4 and A5 (Personal has
    // no Vertical Week).
    "vertical-weekly": {
      label: dyofT("contract.layout.vertical", "Vertical"),
      controls: ["lineStyle", "calendar", "appointmentTimes"]
    },
    monthly: {
      label: dyofT("contract.layout.monthly", "Monthly"),
      controls: ["calendar"]
    }
  };

  var LEGACY_LAYOUTS_BY_SIZE = {
    a4: ["daily", "weekly", "two-weeks", "vertical-weekly", "monthly"],
    a5: ["daily", "weekly", "two-weeks", "vertical-weekly", "monthly"],
    personal: ["daily", "weekly", "two-weeks", "monthly"]
  };

  var MODERN_VARIANTS = {
    weekly: {
      label: dyofT("contract.layout.weekly", "Weekly"),
      views: {
        standard: {
          label: dyofT("contract.view.standard", "Standard"),
          supportedStartDays: ["monday", "sunday"],
          designs: {
            plain: "weekly.standard.plain.a5",
            ruled: "weekly.standard.ruled.a5",
            "to-dos": "weekly.standard.todos.a5"
          }
        },
        "compact-weekend": {
          label: dyofT("contract.view.compact_weekend", "Compact Weekend"),
          supportedStartDays: ["monday"],
          designs: {
            plain: "weekly.compact-weekend.plain.a5",
            ruled: "weekly.compact-weekend.ruled.a5",
            "to-dos": "weekly.compact-weekend.todos.a5"
          }
        },
        "tasks-priorities": {
          label: dyofT("contract.view.tasks_priorities", "Tasks & Priorities"),
          supportedStartDays: ["monday"],
          designs: {
            plain: "weekly.tasks-priorities.plain.a5",
            ruled: "weekly.tasks-priorities.ruled.a5",
            "to-dos": "weekly.tasks-priorities.todos.a5"
          }
        },
        "ideas-notes": {
          label: dyofT("contract.view.ideas_notes", "Ideas & Notes"),
          supportedStartDays: ["monday"],
          designs: {
            plain: "weekly.ideas-notes.plain.a5",
            ruled: "weekly.ideas-notes.ruled.a5",
            "to-dos": "weekly.ideas-notes.todos.a5"
          }
        }
      }
    },
    daily: {
      label: dyofT("contract.layout.daily", "Daily"),
      views: {
        standard: {
          label: dyofT("contract.view.standard", "Standard"),
          supportedStartDays: ["monday", "sunday"],
          designs: {
            plain: "daily.standard.plain.a5",
            ruled: "daily.standard.ruled-w-appts.a5",
            "to-dos": "daily.standard.to-dos.a5"
          }
        },
        "tasks-priorities": {
          label: dyofT("contract.view.tasks_priorities", "Tasks & Priorities"),
          supportedStartDays: ["monday", "sunday"],
          designs: {
            plain: "daily.tasks-and-priorities.plain.a5",
            ruled: "daily.tasks-and-priorities.ruled.a5",
            "to-dos": "daily.tasks-and-priorities.to-dos.a5"
          }
        },
        "ideas-notes": {
          label: dyofT("contract.view.ideas_notes", "Ideas & Notes"),
          supportedStartDays: ["monday", "sunday"],
          designs: {
            plain: "daily.ideas-and-notes.plain.a5",
            ruled: "daily.ideas-and-notes.ruled.a5",
            "to-dos": "daily.ideas-and-notes.to-dos.a5"
          }
        }
      }
    },
    "vertical-weekly": {
      label: dyofT("contract.layout.vertical_weekly", "Vertical Weekly"),
      views: {
        standard: {
          label: dyofT("contract.view.standard", "Standard"),
          supportedStartDays: ["monday"],
          designs: {
            plain: "weekly-vertical.standard.plain.a5",
            ruled: "weekly-vertical.standard.ruled-w-appts.a5",
            "to-dos": "weekly-vertical.standard.ruled-to-dos.a5"
          }
        },
        "tasks-priorities": {
          label: dyofT("contract.view.tasks_priorities", "Tasks & Priorities"),
          supportedStartDays: ["monday"],
          designs: {
            plain: "weekly-vertical.tasks-and-priorities.plain.a5",
            ruled: "weekly-vertical.tasks-and-priorities.ruled.a5",
            "to-dos": "weekly-vertical.tasks-and-priorities.to-dos.a5"
          }
        }
      }
    },
    monthly: {
      label: dyofT("contract.layout.monthly", "Monthly"),
      views: {
        standard: {
          label: dyofT("contract.view.standard", "Standard"),
          supportedStartDays: ["monday", "sunday"],
          designs: {
            "ruled-and-to-dos": "monthly.standard.ruled-and-to-dos.a5",
            "month-days-list": "monthly.standard.month-days-list.a5"
          }
        },
        "tasks-priorities": {
          label: dyofT("contract.view.tasks_priorities", "Tasks & Priorities"),
          supportedStartDays: ["monday", "sunday"],
          designs: {
            "month-on-one-page": "monthly.tasks-and-priorities.month-on-one-page.a5",
            "half-page": "monthly.tasks-and-priorities.half-page.a5"
          }
        }
      }
    }
  };

  // Filofax's October 7 pricing (live 2026-10-08). The Everyday fills are
  // stock fills: the printer prints the standard fill for the SKU and only
  // the cover is personalised, so they sell without production pages.
  // - A Clipbook's refill line is the hidden dyof-everyday-refill product:
  //   the top-level variant (A5, DPP/X1873-X1883, £15) or the Personal
  //   bySize entry (DPP/PE0001-PE0010, £13, Clipbook only).
  // - A Planner stays one line: the custom-notebook "Undated / Undated / X"
  //   variant (PF00077-PF00087, cover and fill together), in plannerVariantId.
  var EVERYDAY_REFILL_HANDLE = "dyof-everyday-refill";
  var PLANNER_PRODUCT_HANDLE = "custom-notebook";

  // Manuela's Personal (95 x 171 mm) Everyday fills, Clipbook only, with
  // their own Personal variants. A Personal order never borrows the A5 one.
  function personalEverydayStockFill(variantId, sku) {
    return {
      status: "ready",
      productTypes: ["clipbook"],
      productHandle: EVERYDAY_REFILL_HANDLE,
      variantId: variantId,
      sku: sku,
      price: 1300,
      stockFill: true
    };
  }

  var UNDATED_FILLS = {
    mix: {
      label: dyofT("contract.fill.mix_ruled_dotted_plain_squared", "Mix (Ruled, Dotted, Plain & Squared)"),
      variantId: "64822150234489",
      sku: "DPP/X1878",
      price: 1500,
      productHandle: EVERYDAY_REFILL_HANDLE,
      plannerVariantId: "44734093197506",
      plannerProductHandle: PLANNER_PRODUCT_HANDLE,
      stockFill: true,
      status: "ready",
      sizes: ["a5", "personal"],
      bySize: {
        personal: personalEverydayStockFill("64822150594937", "DPP/PE0006")
      }
    },
    ruled: {
      label: dyofT("contract.fill.ruled", "Ruled"),
      variantId: "64822150136185",
      sku: "DPP/X1875",
      price: 1500,
      productHandle: EVERYDAY_REFILL_HANDLE,
      plannerVariantId: "44734093099202",
      plannerProductHandle: PLANNER_PRODUCT_HANDLE,
      stockFill: true,
      status: "ready",
      sizes: ["a5", "personal"],
      bySize: {
        personal: personalEverydayStockFill("64822150431097", "DPP/PE0001")
      }
    },
    dotted: {
      label: dyofT("contract.fill.dotted", "Dotted"),
      variantId: "64822150070649",
      sku: "DPP/X1873",
      price: 1500,
      productHandle: EVERYDAY_REFILL_HANDLE,
      plannerVariantId: "44734093033666",
      plannerProductHandle: PLANNER_PRODUCT_HANDLE,
      stockFill: true,
      status: "ready",
      sizes: ["a5", "personal"],
      bySize: {
        personal: personalEverydayStockFill("64822150496633", "DPP/PE0003")
      }
    },
    plain: {
      label: dyofT("contract.fill.plain", "Plain"),
      variantId: "64822150103417",
      sku: "DPP/X1874",
      price: 1500,
      productHandle: EVERYDAY_REFILL_HANDLE,
      plannerVariantId: "44734093066434",
      plannerProductHandle: PLANNER_PRODUCT_HANDLE,
      stockFill: true,
      status: "ready",
      sizes: ["a5", "personal"],
      bySize: {
        personal: personalEverydayStockFill("64822150463865", "DPP/PE0002")
      }
    },
    squared: {
      label: dyofT("contract.fill.squared", "Squared"),
      variantId: "64822150168953",
      sku: "DPP/X1876",
      price: 1500,
      productHandle: EVERYDAY_REFILL_HANDLE,
      plannerVariantId: "44734093131970",
      plannerProductHandle: PLANNER_PRODUCT_HANDLE,
      stockFill: true,
      status: "ready",
      sizes: ["a5", "personal"],
      bySize: {
        personal: personalEverydayStockFill("64822150529401", "DPP/PE0004")
      }
    },
    "dotted-ruled": {
      label: dyofT("contract.fill.dotted_ruled", "Dotted & Ruled"),
      variantId: "64822150201721",
      sku: "DPP/X1877",
      price: 1500,
      productHandle: EVERYDAY_REFILL_HANDLE,
      plannerVariantId: "44734093164738",
      plannerProductHandle: PLANNER_PRODUCT_HANDLE,
      stockFill: true,
      status: "ready",
      sizes: ["a5", "personal"],
      bySize: {
        personal: personalEverydayStockFill("64822150562169", "DPP/PE0005")
      }
    },
    "to-do": {
      label: dyofT("contract.fill.to_do", "To do"),
      variantId: "64822150300025",
      sku: "DPP/X1880",
      price: 1500,
      productHandle: EVERYDAY_REFILL_HANDLE,
      plannerVariantId: "44734093263042",
      plannerProductHandle: PLANNER_PRODUCT_HANDLE,
      stockFill: true,
      status: "ready",
      sizes: ["a5", "personal"],
      bySize: {
        personal: personalEverydayStockFill("64822150660473", "DPP/PE0008")
      }
    },
    "work-life-balance": {
      label: dyofT("contract.fill.work_life_balance", "Work/Life Balance"),
      variantId: "64822150332793",
      sku: "DPP/X1881",
      price: 1500,
      productHandle: EVERYDAY_REFILL_HANDLE,
      plannerVariantId: "44734093295810",
      plannerProductHandle: PLANNER_PRODUCT_HANDLE,
      stockFill: true,
      status: "ready",
      sizes: ["a5", "personal"],
      bySize: {
        personal: personalEverydayStockFill("64822150693241", "DPP/PE0009")
      }
    },
    "self-care": {
      label: dyofT("contract.fill.self_care", "Self-Care"),
      variantId: "64822150267257",
      sku: "DPP/X1879",
      price: 1500,
      productHandle: EVERYDAY_REFILL_HANDLE,
      plannerVariantId: "44734093230274",
      plannerProductHandle: PLANNER_PRODUCT_HANDLE,
      stockFill: true,
      status: "ready",
      sizes: ["a5", "personal"],
      bySize: {
        personal: personalEverydayStockFill("64822150627705", "DPP/PE0007")
      }
    },
    "baby-journal": {
      label: dyofT("contract.fill.baby_journal", "Baby Journal"),
      description: dyofT("contract.description.baby_journal", "A guided journal to preserve every milestone, memory and first. What's inside: Welcome Baby, Growing Together, First Moments, Family & Keepsakes, Letters & Reflections"),
      variantId: "64190103257465",
      plannerVariantId: "64573030760825",
      plannerProductHandle: "dyof-planner-baby-journal-a5",
      sku: "133903",
      price: 1700,
      pageCount: 112,
      sizes: ["a5"],
      status: "ready"
    },
    "wedding-journal": {
      label: dyofT("contract.fill.wedding_journal", "Wedding Journal"),
      description: dyofT("contract.description.wedding_journal", "A guided journal to plan every detail of your wedding and preserve the memories along the way. What's inside: Our Story, Budget & Suppliers, The Countdown, Guests, The Big Day, Memories"),
      variantId: "64190171939193",
      plannerVariantId: "64573073064313",
      plannerProductHandle: "dyof-planner-wedding-journal-a5",
      sku: "133904",
      price: 1700,
      pageCount: 112,
      sizes: ["a5"],
      status: "ready"
    },
    "gardening-journal": {
      label: dyofT("contract.fill.gardening_journal", "Gardening Journal"),
      description: dyofT("contract.description.gardening_journal", "A guided journal to plan, nurture and keep track of your garden through every season. What's inside: Getting Started, Planning & Organisation, Garden Records, Garden Care, Seasonal Sections, Year Reflection"),
      variantId: "64190221812089",
      plannerVariantId: "64573073490297",
      plannerProductHandle: "dyof-planner-gardening-journal-a5",
      sku: "133905",
      price: 1700,
      pageCount: 112,
      sizes: ["a5"],
      status: "ready"
    },
    "life-essentials": {
      label: dyofT("contract.fill.life_essentials", "Life Essentials"),
      description: dyofT("contract.description.life_essentials", "A guided journal to keep life's important information secure and organised. What's inside: Getting Started, Important Information, Accounts A–Z, Email & Devices, Software & Subscriptions, Looking Ahead"),
      variantId: "64190358389113",
      plannerVariantId: "64573073916281",
      plannerProductHandle: "dyof-planner-life-essentials-a5",
      sku: "133906",
      price: 1700,
      pageCount: 112,
      sizes: ["a5"],
      status: "ready"
    },
    "cookbook-journal": {
      label: dyofT("contract.fill.cookbook_journal", "Cookbook Journal"),
      description: dyofT("contract.description.cookbook_journal", "A guided journal to collect favourite recipes, flavours and kitchen inspiration. What's inside: Getting Started, Kitchen Essentials, Recipe Collection, Recipe Records, Future Recipes"),
      variantId: "64190439719289",
      plannerVariantId: "64573074375033",
      plannerProductHandle: "dyof-planner-cookbook-journal-a5",
      sku: "133907",
      price: 1700,
      pageCount: 112,
      sizes: ["a5"],
      status: "ready"
    },
    "pet-journal": {
      label: dyofT("contract.fill.pet_journal", "Pet Journal"),
      description: dyofT("contract.description.pet_journal", "A guided journal to care for your pet and preserve the moments you share together. What's inside: Getting Started, Daily Life, Health & Care, Training & Growth, Pet Sitting, Memories"),
      variantId: "64189176185209",
      plannerVariantId: "64573074964857",
      plannerProductHandle: "dyof-planner-pet-journal-a5",
      sku: "133902",
      price: 1700,
      pageCount: 112,
      sizes: ["a5"],
      status: "ready"
    },
    "undated-weekly": {
      label: dyofT("contract.fill.undated_planner_week_to_view", "Undated Planner - Week to view"),
      variantId: "64822150365561",
      sku: "DPP/X1882",
      price: 1500,
      productHandle: EVERYDAY_REFILL_HANDLE,
      plannerVariantId: "44734093328578",
      plannerProductHandle: PLANNER_PRODUCT_HANDLE,
      stockFill: true,
      status: "ready",
      sizes: ["a5", "personal"],
      bySize: {
        personal: personalEverydayStockFill("64822150726009", "DPP/PE0010")
      }
    },
    // A5 only: there is no Personal Vertical week to view.
    "undated-vertical-weekly": {
      label: dyofT("contract.fill.undated_planner_vertical_week_to_view", "Undated Planner - Vertical week to view"),
      variantId: "64822150398329",
      sku: "DPP/X1883",
      price: 1500,
      productHandle: EVERYDAY_REFILL_HANDLE,
      plannerVariantId: "44734093361346",
      plannerProductHandle: PLANNER_PRODUCT_HANDLE,
      stockFill: true,
      status: "ready",
      sizes: ["a5"]
    }
  };

  // New Colourful (October 7 pricing): every modern style at A5 is sold as
  // the hidden dyof-new-colourful-refill product, one variant per layout for
  // white and cream paper alike, never a legacy Classic or Luxury refill.
  // Weekly and Vertical share the SKU 27-A50003 but are separate variants.
  // Two Weeks to View has no modern layout yet, so it is listed but unused.
  // A Planner is one custom-notebook line, priced as its Luxury variant.
  var NEW_COLOURFUL_REFILLS = {
    productHandle: "dyof-new-colourful-refill",
    sizes: ["a5"],
    plannerStyle: "luxury",
    byLayout: {
      monthly: { variantId: "64822150758777", sku: "27-A50001", price: 1200 },
      "two-weeks": { variantId: "64822150791545", sku: "27-A50002", price: 1500 },
      weekly: { variantId: "64822150824313", sku: "27-A50003", price: 2100 },
      "vertical-weekly": { variantId: "64822150857081", sku: "27-A50003", price: 2100 },
      daily: { variantId: "64822150889849", sku: "27-A50004", price: 3200 }
    }
  };

  function own(object, key) {
    return Object.prototype.hasOwnProperty.call(object, key);
  }

  function getStyle(styleKey) {
    return own(STYLES, styleKey) ? STYLES[styleKey] : null;
  }

  function getModernView(layoutKey, viewKey) {
    var layout = own(MODERN_VARIANTS, layoutKey) ? MODERN_VARIANTS[layoutKey] : null;
    return layout && own(layout.views, viewKey) ? layout.views[viewKey] : null;
  }

  function getLegacyLayout(layoutKey) {
    return own(LEGACY_VARIANTS, layoutKey) ? LEGACY_VARIANTS[layoutKey] : null;
  }

  function getSupportedLegacyLayouts(size) {
    return own(LEGACY_LAYOUTS_BY_SIZE, size)
      ? LEGACY_LAYOUTS_BY_SIZE[size].slice()
      : [];
  }

  function isDatedLayoutSupported(selection, productType) {
    var input = selection || {};
    var layout = input.layout || String(input.variant || "").split(".")[0];
    // SEP 15 feedback: Daily remains a Refill/Clipbook choice, not a Planner.
    // Keep this product rule separate from renderer and Shopify availability.
    return productType !== "planner" || layout !== "daily";
  }

  // Printed legacy first-page content; the content-language lane owns these labels.
  function getLegacyFirstPageLabel(selection) {
    var input = selection || {};
    if (input.layout === "daily") return "DAY TO VIEW";
    if (input.layout === "weekly") {
      return input.notes ? "WEEK TO VIEW WITH NOTES" : "WEEK TO VIEW";
    }
    if (input.layout === "two-weeks") return "TWO WEEKS TO VIEW";
    if (input.layout === "vertical-weekly") return "VERTICAL WEEK TO VIEW";
    return "MONTH TO VIEW";
  }

  function resolveModernVariant(selection) {
    var input = selection || {};
    var layoutKey = input.layout;
    var viewKey = input.layoutView || input.view;
    var designKey = input.dayDesign || input.monthDesign || input.design;
    var style = getStyle(input.style);
    var view;

    if (style && style.engine !== "modern") {
      throw new Error("Style " + input.style + " belongs to the legacy renderer.");
    }

    view = getModernView(layoutKey, viewKey);
    if (!view) {
      throw new Error("Unsupported modern layout/view: " + layoutKey + "/" + viewKey + ".");
    }
    if (!own(view.designs, designKey)) {
      throw new Error(
        "Unsupported design " + designKey + " for " + layoutKey + "/" + viewKey + "."
      );
    }

    return view.designs[designKey];
  }

  function getSupportedStartDays(selection) {
    var input = selection || {};
    if (input.engine === "legacy") {
      return ["monday", "sunday"];
    }
    var view = getModernView(input.layout, input.layoutView || input.view);
    return view ? view.supportedStartDays.slice() : [];
  }

  function isSupportedStartDay(selection) {
    return getSupportedStartDays(selection).indexOf(selection && selection.startDay) !== -1;
  }

  function getSupportedDatePositions(selection) {
    var input = selection || {};
    var layoutKey = input.layout || String(input.variant || "").split(".")[0];
    var viewKey = input.layoutView || input.view || String(input.variant || "").split(".")[1];

    if (layoutKey === "weekly" && viewKey === "ideas-notes") {
      return ["left-aligned"];
    }

    return layoutKey === "weekly" || layoutKey === "daily"
      ? DATE_POSITIONS.slice()
      : ["left-aligned"];
  }

  function getUndatedFill(fillKey) {
    return own(UNDATED_FILLS, fillKey) ? UNDATED_FILLS[fillKey] : null;
  }

  // What an Undated fill sells at one size, as a Clipbook's refill line. A5
  // is the fill's top-level variant; any other size needs its own bySize
  // entry and never falls back to the A5 variant, SKU, price or page count.
  // Status is "ready", "preview-only" (shown, not sold) or "unavailable" (not
  // offered). A stock fill sells without production pages (pageCount null).
  // A Planner's one line is plannerVariantId instead (dyof-configurator.js).
  function getUndatedPurchase(fillKey, size, productType) {
    var fill = getUndatedFill(fillKey);
    var sizeKey = String(size || "").trim().toLowerCase();
    var entry;
    var unavailable = {
      status: "unavailable",
      variantId: null,
      sku: null,
      price: null,
      pageCount: null,
      productHandle: null,
      stockFill: false
    };

    if (!fill || !sizeKey || (Array.isArray(fill.sizes) && fill.sizes.indexOf(sizeKey) === -1)) {
      return unavailable;
    }
    entry = fill.bySize && own(fill.bySize, sizeKey) ? fill.bySize[sizeKey] : null;
    if (entry) {
      if (Array.isArray(entry.productTypes) && entry.productTypes.indexOf(productType) === -1) {
        return unavailable;
      }
      return {
        status: entry.status === "ready" && !entry.variantId ? "unavailable" : String(entry.status || "unavailable"),
        variantId: entry.variantId || null,
        sku: entry.sku || null,
        price: entry.price == null ? null : entry.price,
        pageCount: entry.pageCount || null,
        productHandle: entry.productHandle || null,
        stockFill: entry.stockFill === true
      };
    }
    if (sizeKey !== "a5") {
      return unavailable;
    }
    return {
      status: fill.status,
      variantId: fill.variantId || null,
      sku: fill.sku || null,
      price: fill.price == null ? null : fill.price,
      pageCount: fill.pageCount || null,
      productHandle: fill.productHandle || null,
      stockFill: fill.stockFill === true
    };
  }

  // The New Colourful variant a modern layout sells as, or null (another
  // size, or a layout without one). Paper colour does not change it.
  function getNewColourfulRefill(layoutKey, size) {
    var sizeKey = String(size || "").trim().toLowerCase();
    var entry = own(NEW_COLOURFUL_REFILLS.byLayout, layoutKey)
      ? NEW_COLOURFUL_REFILLS.byLayout[layoutKey]
      : null;
    if (!entry || NEW_COLOURFUL_REFILLS.sizes.indexOf(sizeKey) === -1 || !own(MODERN_VARIANTS, layoutKey)) {
      return null;
    }
    return {
      productHandle: NEW_COLOURFUL_REFILLS.productHandle,
      variantId: entry.variantId,
      sku: entry.sku,
      price: entry.price
    };
  }

  function getSingleColours(styleKey) {
    var palette = own(SINGLE_COLOUR_PALETTES, styleKey)
      ? SINGLE_COLOUR_PALETTES[styleKey]
      : [];

    return palette.map(function(swatches, index) {
      return {
        value: "colour-" + String(index + 1).padStart(2, "0"),
        label: dyofT("contract.colour.number", "Colour {number}", { number: index + 1 }),
        swatches: swatches.slice()
      };
    });
  }

  function resolveFirstPageBackground(selection) {
    var input = selection || {};
    var colours = own(FIRST_PAGE_BACKGROUND_COLOURS, input.style)
      ? FIRST_PAGE_BACKGROUND_COLOURS[input.style]
      : FIRST_PAGE_BACKGROUND_COLOURS.gradient;
    var match = /^colour-(\d{2})$/.exec(String(input.singleColour || ""));
    var index = input.colourMode === "single-colour" && match
      ? Math.max(0, Number(match[1]) - 1)
      : 0;

    return colours[index] || colours[0] || "#C8A3CD";
  }

  return {
    __loaded: true,
    version: "2026-08-06.2",
    launchSize: "a5",
    legacySizes: ["a4", "a5", "personal"],
    styles: STYLES,
    legacyVariants: LEGACY_VARIANTS,
    modernVariants: MODERN_VARIANTS,
    undatedFills: UNDATED_FILLS,
    newColourfulRefills: NEW_COLOURFUL_REFILLS,
    controls: {
      colourModes: COLOUR_MODES,
      paperColours: PAPER_COLOURS,
      datePositions: DATE_POSITIONS,
      headerThemes: HEADER_THEMES,
      languages: LANGUAGES,
      firstPageColours: FIRST_PAGE_COLOURS,
      minimalFirstPageColours: MINIMAL_FIRST_PAGE_COLOURS,
      personalisationColours: PERSONALISATION_COLOURS,
      countryHolidayGroups: COUNTRY_HOLIDAY_GROUPS,
      religiousHolidayGroups: RELIGIOUS_HOLIDAY_GROUPS,
      personalDateFrequencies: PERSONAL_DATE_FREQUENCIES,
      moonTimezoneOffsets: MOON_TIMEZONE_OFFSETS,
      defaultMoonTimezoneOffset: DEFAULT_MOON_TIMEZONE_OFFSET
    },
    paperPolicy: {
      white: {
        websitePreview: "white",
        pdfBackground: "white",
        productionStock: "white"
      },
      cream: {
        websitePreview: "cream",
        pdfBackground: "white",
        productionStock: "cream"
      }
    },
    pdfGaps: [],
    pdfApprovalGates: [
      "customer visual approval of generated control proofs"
    ],
    resolveModernVariant: resolveModernVariant,
    getSupportedStartDays: getSupportedStartDays,
    isSupportedStartDay: isSupportedStartDay,
    getSupportedDatePositions: getSupportedDatePositions,
    getLegacyLayout: getLegacyLayout,
    getSupportedLegacyLayouts: getSupportedLegacyLayouts,
    isDatedLayoutSupported: isDatedLayoutSupported,
    getLegacyFirstPageLabel: getLegacyFirstPageLabel,
    getStyle: getStyle,
    getUndatedFill: getUndatedFill,
    getUndatedPurchase: getUndatedPurchase,
    getNewColourfulRefill: getNewColourfulRefill,
    getSingleColours: getSingleColours,
    resolveFirstPageBackground: resolveFirstPageBackground
  };
});
